import { publicUrl, http } from 'utils'
import storage from 'store'
import store from 'vx/store'
import router from '@/router'
import Vue from 'vue'
import identify from './identify'

export default {
  /**
   * Get the token.
   *
   * @return string
   */
  getToken () {
    return storage.get('token')
  },

  /**
   * Attempt authentication via the token.
   *
   * @return Promise
   */
  attemptViaToken () {
    // If the user is authorized already then we can just resolve this promise
    // as we do not need to fetch their details again.
    if (
      store.getters['authentication/authorized'].id !== undefined &&
      store.getters['authentication/authorized'].id !== null
    ) {
      return Promise.resolve()
    }

    return this.attemptSessionInitialization()
      .then(() => {
        if (
          store.getters['authentication/authorized'].role === null ||
          store.getters['authentication/authorized'].role === undefined
        ) {
          return Promise.reject(new Error('User does not have a role and is unable to access application.'))
        }
        if (Vue.prototype.$analytics) {
          let domain = window.location.hostname.split('.')[0]
          if (store.getters['clientConfig/client_config'] && store.getters['clientConfig/client_config'].slug) {
            domain = store.getters['clientConfig/client_config'].tenant_details.client_platform
          }
          const isVlast = store.getters['clientConfig/client_config'] && store.getters['clientConfig/client_config'].modules && store.getters['clientConfig/client_config'].modules.vlast_mode
          const userDetails = identify.getTrackingUser(store.getters['authentication/authorized'], domain, isVlast)
          Vue.prototype.$analytics.identify(userDetails)
        }

        return Promise.resolve()
      })
  },

  /**
   * Attempt to initialize the session and authorize.
   *
   * @return Promise
   */
  async attemptSessionInitialization () {
    await store.dispatch('authentication/authorize', this.getToken())
    return store.dispatch('clientConfig/getClientConfig').then(response => {
      window.document.title = response.data.tenant_details.application_name
    })
  },

  /**
   * Redirect to login if token expires without refreshing.
   *
   * @return void
   */
  redirectOnTokenExpired (intendedRoute) {
    const region = this.$user ? this.$user.region.shortname : 'au'
    if (process.env.VLAST_MODE) {
      if (router.currentRoute.name !== 'login') {
        router.push({ name: 'login', query: { redirect: router.currentRoute.path } })
      }
      this.logout()
    } else {
      this.logout()

      let redirectPath = intendedRoute === undefined
        ? window.location.pathname
        : intendedRoute.path

      window.location.assign(publicUrl(`login?redirect=${redirectPath}&context=app`, region))
    }
  },

  /**
   * Redirect to dashboard if a forbidden response is received.
   *
   * @return void
   */
  redirectOnForbidden () {
    router.push({ name: 'dashboard', query: { src: 'auth' } })
  },

  /**
   * Log the user out. Clear the storage token.
   *
   * @return Promise
   */
  logout () {
    return store.dispatch('authentication/logout')
  },

  /**
   * Setup the session regeneration for the Laravel application. We need to poll the server
   * occasionally so we don't end up logged out.
   *
   * @return Promise
   */
  setupSessionRegeneration () {
    // Set the regeneration timeout period to be 30 minutes.
    const regenerationPeriod = 30 * 60 * 1000

    const sessionRegenerator = () => {
      const config = {
        baseURL: publicUrl(),
        disableAuthorization: true
      }

      return http.get('session-refresh', config)
        .then(() => {
          setTimeout(sessionRegenerator, regenerationPeriod)
        })
    }

    setTimeout(sessionRegenerator, regenerationPeriod)

    return sessionRegenerator()
  }
}
